import { render, staticRenderFns } from "./automaticDropdown-editor.vue?vue&type=template&id=0cf7d2c6&scoped=true&"
import script from "./automaticDropdown-editor.vue?vue&type=script&lang=js&"
export * from "./automaticDropdown-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7d2c6",
  null
  
)

export default component.exports